import { render, staticRenderFns } from "./order-delete.vue?vue&type=template&id=13dbece4&"
import script from "./order-delete.vue?vue&type=script&lang=js&"
export * from "./order-delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports